module.exports = function (angularModule) {
  angularModule.factory('providerJobStatusService',
    function providerJobStatusService($http, $log, timePeriodService) {

      var possibleStatuses = [
        { code: "AllIsWell",         title: "All Good",        description: "Majority of jobs are finishing successfully and yielding results" },
        { code: "BackedUp",          title: "Backed Up",       description: "Jobs are being rate limited, and progress is slowed"              },
        { code: "FailingSilently",   title: "May be Broken",   description: "Jobs claim to be running, but are not yielding results"           },
        { code: "FailingWithABang",  title: "Broken",          description: "At least 1 in 5 jobs is erring"                                   },
        { code: "NoRecentJobs",      title: "Not Enough Data", description: "Not enough recent jobs to determine status"                       },
        { code: "NotCompatible",     title: "Not Compatible",  description: "This job type is not compatible with this provider"               },
      ];
      var jobTypes = [
        { code: "FetchReviews",   display: "Reviews"        },
        { code: "FindListings",   display: "Listings"       },
        { code: "LocalRankings",  display: "Local Rankings" },
        { code: "WebRankings",    display: "Web Rankings"   },
        { code: "FetchImages",    display: "Images"         },
        { code: "FetchSocialListingPosts",    display: "Social Posts"},
        { code: "FetchSocialListingStats",    display: "Social Stats"},
      ];

      var statusLookup = {};
      possibleStatuses.forEach(function(status) {
        statusLookup[status.code] = status;
      });

      function keyOnJobType(list) {
        return list.reduce(function(keyed, statusItem) {
          keyed[statusItem.jobType] = statusItem;
          return keyed;
        }, {});
      }

      var service = {
        buildColumnsFromUnorderedStatusItems: function(list) {
          var byJobType = keyOnJobType(list || []);
          var statusItems = jobTypes.map(function(jobType) {
            var statusItem = byJobType[jobType.code];
            if (!statusItem) return null;

            function countToSize(count) {
              if (count < 333)        return "x-small";
              else if (count < 1000)  return "small";
              else if (count < 3333)  return "medium";
              else if (count < 10000) return "large";
              else if (count < 33333) return "x-large";
              else                    return "xx-large";
            }

            var decimal = statusItem.counts.SuccessfulJob / (statusItem.counts.SuccessfulJob + (statusItem.counts.FailedJobResult / 5));
            var percentSucceeded = Math.round((decimal || 0) * 100);

            var counts = angular.extend({}, statusItem.counts, {
              percentSucceeded: percentSucceeded
            });

            var statusDetails = statusLookup[statusItem.providerJobStatus];
            var hoverText = statusDetails.title + ": " + statusDetails.description;
            Object.keys(counts).sort().forEach(function (k) {
              hoverText += "\n\t" + k + ": " + counts[k];
            });


            return angular.extend({}, statusItem, {
              statusDetails: statusDetails,
              hoverText: hoverText,
              jobTypeDetails: jobType,
              sizeDescriptor: countToSize(statusItem.counts.total || 0),
              percentSucceeded: percentSucceeded + "%",
              counts: counts
            });
          });

          return statusItems;
        },
        getStatusForDateRange: function (startDate, endDate) {
          return $http.get('/healthmeter/providerjobstatus/timerange', {
            params: {
              start: startDate, end: endDate
            }
          })
        },
        jobTypes: jobTypes,
        possibleStatuses: possibleStatuses,
        statusLookup: statusLookup,
        millisPerDay: 24 * 60 * 60 * 1000,
        getStatusForPeriod: function({ periodType, offset }) {
          var { start, end } = timePeriodService.periodToDateRange({ periodType, offset });
          return service.getStatusForDateRange(start,end);
        },
      }
      return service;
    });

};
